import { applyInverseTransform, distanceToLine, getPivot } from "@project-rouge/rg-three";
import { Vector3 } from "three";
function calculateMuscleCoreFireDoorsPositions(muscleCores, corridor, centerline, deadEndDistance) {
	const positions = [];
	for (let i = 0; i < muscleCores.length; i++) {
		const core = muscleCores[i];
		const corePiv = getPivot([
			.5,
			0,
			0
		], core);
		const d1 = distanceToLine(corePiv, centerline).closest.distanceTo(new Vector3(...centerline[0]));
		const d2 = distanceToLine(corePiv, centerline).closest.distanceTo(new Vector3(...centerline[1]));
		let pivs = [];
		if (Math.min(d1, d2) < core.size[0]) continue;
		else if (i === 0 && Math.min(d1, d2) <= deadEndDistance) pivs = [d1 > d2 ? 0 : 1];
		else if (i === muscleCores.length - 1 && Math.min(d1, d2) <= deadEndDistance) pivs = [d1 > d2 ? 1 : 0];
		else pivs = [0, 1];
		for (const pivX of pivs) {
			const { closest } = distanceToLine(getPivot([
				pivX,
				0,
				0
			], core), centerline);
			const pos = applyInverseTransform(closest.toArray(), corridor);
			positions.push(pos);
		}
	}
	return positions;
}
export { calculateMuscleCoreFireDoorsPositions };

//# sourceMappingURL=index44.js.map